var _circle, _circle2, _text, _text2, _text3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#f5f5f5",
    stroke: "#e0e0e0",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 24,
    fill: "#fff",
    stroke: "#00b890",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 26,
    textAnchor: "middle",
    fontFamily: "Arial,sans-serif",
    fontSize: 8,
    fill: "#00b890",
    fontWeight: 700
  }, "MONEY")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 34,
    textAnchor: "middle",
    fontFamily: "Arial,sans-serif",
    fontSize: 8,
    fill: "#00b890",
    fontWeight: 700
  }, "BACK")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 32,
    y: 42,
    textAnchor: "middle",
    fontFamily: "Arial,sans-serif",
    fontSize: 6,
    fill: "#00b890"
  }, "GUARANTEE")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyBack);
export default __webpack_public_path__ + "static/media/money-back.728af877cf2ece75f7b78c6f0c0ffb56.svg";
export { ForwardRef as ReactComponent };